import AccountsDashboard from "@/pages/accounts/AccountsDashboard";

export default function AdminAccounts() {
  return <AccountsDashboard />;
}
